"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const getContentType_1 = require("../helpers/getContentType");
const getState_1 = require("../helpers/getState");
const entity_1 = require("../type/entity");
const updateUnitsCompletedForNonLeafNode_1 = require("./helpers/updateUnitsCompletedForNonLeafNode");
/**
 * This function also updates unitsCompleted field on
 * curriculum, course and section level.
 */
// @ts-ignore: maintain function signature
function updateUnitsCompletedCount(command, user, content, states) {
    const state = getState_1.getStateByContentIdUserId(states, content._id, user.userId);
    const contentType = getContentType_1.getContentType(content);
    switch (contentType) {
        case entity_1.ContentType.SECTION:
        case entity_1.ContentType.COURSE: {
            const childrenContentIds = content.children.map((c) => c._id);
            updateUnitsCompletedForNonLeafNode_1.updateUnitsCompletedForNonLeafNode(state, user, childrenContentIds, states);
            break;
        }
        case entity_1.ContentType.CURRICULUM: {
            const childrenContentIds = content.offers.map((c) => c.offerId);
            updateUnitsCompletedForNonLeafNode_1.updateUnitsCompletedForNonLeafNode(state, user, childrenContentIds, states);
            break;
        }
        default:
            break;
    }
    return [];
}
exports.updateUnitsCompletedCount = updateUnitsCompletedCount;
//# sourceMappingURL=updateUnitsCompletedCount.js.map